import { render, staticRenderFns } from "./BankaPicker.vue?vue&type=template&id=5ffa2c32&scoped=true"
import script from "./BankaPicker.vue?vue&type=script&lang=ts"
export * from "./BankaPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffa2c32",
  null
  
)

export default component.exports